import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        // Clear hash and go to admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data?.user } });
      } catch (e) {
        const detail = e?.response?.data?.detail || "Sign-in failed";
        navigate("/admin", { replace: true, state: { error: detail } });
      }
    })();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-[#1e1b4b]" />
        <p className="mt-4 text-sm text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
